import { InputLabel, MenuItem, Select } from '@material-ui/core'
import React from 'react'

import { useStyles } from './styles'

interface SelectProps {
  label: string
  options: string[]
  value: string
  onChange: (
    event: React.ChangeEvent<{ name?: string | undefined; value: unknown }>,
  ) => void
  name: string
}

export default function SelectInput({
  label,
  options,
  value,
  onChange,
  name,
}: SelectProps) {
  const classes = useStyles()
  return (
    <div className={classes.filterInputs}>
      <InputLabel className={classes.label}>{label}</InputLabel>
      <Select
        className={classes.select}
        label={label}
        value={value}
        onChange={onChange}
        name={name}
        fullWidth
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </div>
  )
}
